import { X } from 'lucide-react';

interface FloatingActionBarProps {
  selectedCount: number;
  children: React.ReactNode;
  onClear: () => void;
}

export function FloatingActionBar({ selectedCount, children, onClear }: FloatingActionBarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
      <div className="flex items-center gap-3 bg-primary text-primary-foreground px-4 py-2 rounded-full shadow-lg">
        <span className="text-sm font-medium">{selectedCount} selected</span>
        <div className="h-4 w-px bg-primary-foreground/30" />
        {children}
        <button onClick={onClear} className="ml-2 hover:opacity-80">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
